module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-public-2775877e.svg";